import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  form: {
    marginTop: '20px',
  },
  text: {
    marginBottom: 20,
    color: '#343434',
  },
  input: {
    marginBottom: 30,
  },
  title: {
    marginTop: 15,
    fontSize: 33,
  },
}));
